import React, { useState, useEffect } from 'react';
import { useSettings, useStore } from '../../listing-app/context/store';

import FilterMultiselect from '../../listing-app/components/filters/FilterMultiselect';
import FilterRange from '../../listing-app/components/filters/FilterRange';
import FilterPills from '../../listing-app/components/filters/FilterPills';
import FilterTrueFalse from '../../listing-app/components/filters/FilterTrueFalse';

export default function Filters() {
    const { 
        state,
        dispatch 
    } = useStore();

    const settings = useSettings();

    const toggleParentActiveClass = ( e, reset = true ) => {
        const isActive = e.currentTarget.parentNode.classList.contains('active')
        
        if ( reset ) {
            document.querySelectorAll('.ygl-filter').forEach( elem => {
                elem.classList.remove('active');
            })

            if ( ! isActive ) {
                e.currentTarget.parentNode.classList.add('active')
            }
        } else {
            e.currentTarget.parentNode.classList.toggle('active')
        }
    }

    if ( 'undefined' !== typeof settings && settings.filters.length && 'undefined' !== typeof state ) {

        return (
            <div className="ygl-filters">
                <div className="container">
                    {settings.filters.map( (filter, index) => {
                        if ( 
                            filter.name === 'Neigborhoods' ||
                            filter.name === 'Price' ||
                            filter.name === 'Beds'
                        ) {
                            switch ( filter.type ) {
                                case 'multiselect':
                                    return <FilterMultiselect toggleParentActiveClass={ toggleParentActiveClass } filter={ filter } key={ index } />
                                case 'range':
                                    return <FilterRange toggleParentActiveClass={ toggleParentActiveClass } filter={ filter } key={ index } />
                                case 'pills':
                                    return <FilterPills toggleParentActiveClass={ toggleParentActiveClass } filter={ filter } key={ index } />
                                case 'true_false':
                                    return <FilterTrueFalse toggleParentActiveClass={ toggleParentActiveClass } filter={ filter } key={ index } />
                                default:
                                    console.warn( `No filter mapping for type: ${filter.type}` );
                            }
                        }
                    })}
                </div>
            </div>
        )
    }

    return '';
}